import styled, { css } from "styled-components";

export const LoanSummaryWrapper = styled.div`
  display: flex;
  flex-direction: column;
  row-gap: 1rem;
  justify-content: center;
  align-items: center;
  width: ${(props) => (props.width ? props.width : "100%")};
  .pageSubTitle {
    text-align: center;
    padding-left: 30px;
    padding-right: 30px;
  }
  .summary-container {
    display: flex;
    flex-direction: column;
    justify-content: center;
    align-items: center;
    width: 100%;
  }
  .summary-box {
    display: flex;
    flex-direction: column;
    background-color: #fffbfb;
    border: 1px solid #ebdede;
    border-radius: 5px;
    width: 100%;
  }
  .summary-box-inside {
    display: flex;
    flex-direction: column;
    margin-left: 15px;
    margin-right: 15px;
    margin-top: 2px;
    margin-bottom: 5px;
  }
  .terms-and-conditions {
    margin-top: 20px;
    font-size: 12px;
    color: #747474;
    text-align: center;
    line-height: 14px;
    margin-left: 5px;
    margin-right: 5px;
    margin-bottom: 20px;
  }
`;
